<section class="hidden w-full select-none bg-primary xl:block">
    <div class="container grid grid-cols-7 py-5 mx-auto custom-grid">
        @for (item of menus(); track $index) {
            <a
                [cdkMenuTriggerFor]="item.children?.length ? menus : null"
                (click)="handleNavigate($event, item)"
                class="flex items-center gap-2 transition-all duration-300 ease-in-out cursor-pointer menu-item hover:opacity-70"
            >
                <app-icon
                    [name]="item.icon || ''"
                    size="md"
                    [ngClass]="
                        path()?.includes(item.url)
                            ? 'text-white'
                            : 'text-primary-300'
                    "
                />
                <span
                    [ngClass]="
                        path()?.includes(item.url)
                            ? 'text-white'
                            : 'text-primary-300'
                    "
                    >{{ item.title }}
                </span>
            </a>

            <ng-template #menus>
                <div
                    cdkMenu
                    class="flex flex-col gap-1 p-1.5 mt-6 rounded-xl bg-primary"
                >
                    @for (child of item.children; track $index) {
                        <button
                            cdkMenuItem
                            (click)="handleNavigate($event, child)"
                            class="bg-primary text-left text-white transition-colors px-3 py-2 rounded-lg hover:bg-primary-450 min-w-[7.5rem]"
                        >
                            {{ child.title }}
                        </button>
                    }
                </div>
            </ng-template>
        }
    </div>
</section>
